import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';
import { AuthStorage } from './authStorage';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

// Add Authorization header automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = AuthStorage.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Optionally handle 401 responses globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      AuthStorage.removeToken();
      if (typeof window !== 'undefined' && window.location && window.location.pathname !== '/login') {
        window.location.replace('/login');
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
